/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".star[_ngcontent-%COMP%] {\n  font-size: 3.5rem;\n  color: #b0c4de;\n  margin: 0px 0px 0px 0px;\n  padding: 0px 0px 0px 0px; }\n\n.filled[_ngcontent-%COMP%] {\n  color: #26266B; }\n\n.bad[_ngcontent-%COMP%] {\n  color: #deb0b0; }\n\n.filled.bad[_ngcontent-%COMP%] {\n  color: #ff1e1e; }\n\n.no-outline[_ngcontent-%COMP%] {\n  outline: none; }\n\n.modal-title[_ngcontent-%COMP%] {\n  margin: 0 auto; }\n\n.color-rating-error[_ngcontent-%COMP%] {\n  color: #EE0000; }"];
export { styles as styles };
